import { StrictMode } from 'react'
import './i18n'
import { hydrateRoot, createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const rootElement = document.getElementById('root')!;

const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// Only hydrate if the root contains SSG-generated content (marked with data-ssg attribute).
// The static HTML fallback in index.html is for crawlers only and must NOT be hydrated.
if (rootElement.dataset.ssg === 'true') {
  hydrateRoot(rootElement, app);
} else {
  // Clear any static fallback HTML before mounting to avoid hydration mismatch.
  rootElement.innerHTML = '';
  createRoot(rootElement).render(app);
}